import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Divider,
} from "@mui/material";

import proArrow from "../../../assets/proArrow.png";
import changeArrow from "../../../assets/changeArrow.png";

import paytm from "../../../assets/Paytm.png";
import r_wallet_card from "../../../assets/r_card.png";
import card_icon from "../../../assets/card.png";
import upi_icon from "../../../assets/upi_1.png";
import bpPg from "../../../assets/bpPg.png";
import dpPg from "../../../assets/dpPg.png";
import pluxee from "../../../assets/plx-logo.svg";

import { useLocation, useNavigate } from "react-router-dom";

const PaymentBottomBar = ({
  fullObjectRewardCart,
  itemsList,
  CreateOrderApi,
  paymentOptionData
}) => {
    const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const machineId = searchParams.get("machineId");
  const navigate = useNavigate();

  const rewardData = fullObjectRewardCart?.data?.reward;
  const comboCart = fullObjectRewardCart?.data?.comboCart;
const cartItems = fullObjectRewardCart?.data?.items || [];
  /** ------------------------------
   *  TOTALS CALCULATION
   * ------------------------------ */
  const totalAmount = fullObjectRewardCart?.data?.items?.reduce(
    (sum, item) => sum + item.amount * item.count,
    0
  ) || 0;

  const discountedTotal = fullObjectRewardCart?.data?.items?.reduce(
    (sum, item) => sum + (item.discountedAmount ?? 0),
    0
  ) || 0;

  const discountValue = rewardData?.count || 0;
  const discountApplied = rewardData?.discountApplied;

  const finalAmountAfterDiscount = discountApplied
    ? totalAmount - discountValue
    : totalAmount;

  let finalAmount = discountedTotal || totalAmount;
  if (!finalAmount && comboCart) {
    finalAmount = comboCart.totalPrice;
  }

  /** computed totals (fallbacks) */
  const fallbackTotal = itemsList?.reduce(
    (sum, item) => sum + item.amount * item.count,
    0
  ) || 0;

  const fallbackDiscountTotal = itemsList?.reduce(
    (sum, item) =>
      sum + (item.discountedAmount || item.amount * item.count),
    0
  ) || 0;
;  
  /** --------------------------------
   *  PAYMENT LOGIC + STORAGE SAVE
   * -------------------------------- */
  const handlePlaceOrder = () => {
    let amountToStore = finalAmountAfterDiscount;

    if (rewardData?.type === "discount") {
      amountToStore = finalAmount;
    }

    if (comboCart) {
      amountToStore = comboCart.totalPrice * comboCart.count;
    }

    localStorage.setItem("finalAmount", amountToStore);
    CreateOrderApi();
  };

  const goToLogin = () => {
   
   // navigate(`/login?route=myCart&machineId=${machineId}`);
   navigate("/login", {state: { from: location.pathname + location.search }, });
    
  };

  const goToPaymentOptions = () => {
    navigate("/paymentOptions?route=mycart");
  };

  /** --------------------------------
   *  PAYMENT LOGO + NAME
   * -------------------------------- */
  const paymentPG = localStorage.getItem("defaultPgName");

  const paymentLogos = {
    WALLET: bpPg,
    WALLET_LOYALTY: dpPg,
    SODEXO: pluxee,
    PAYTM: paytm,
    R_WALLET: r_wallet_card,
    R_CARD: card_icon,
    R_UPI: upi_icon,
  };

  const paymentNames = {
    PAYTM: "Paytm Wallet",
    WALLET_LOYALTY: "Daalchini Points",
    WALLET: "Business Payments",
    SODEXO: "Pluxee",
    RAZORPAY: "Razorpay",
    R_CARD: "Debit/Credit Card",
    R_UPI: "UPI",
    R_WALLET: "Wallet",
  };

  const renderPaymentLogo = () => {
    const logo = paymentLogos[paymentPG];
    if (!logo) return null;

    return (
      <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 35,
            height: 35,
            border: "1px solid rgba(148,163,184,0.5)",
            borderRadius: "5px",
          }}
        >
          <img src={logo} alt="payment-logo" style={{ height: paymentPG === "R_UPI" ? 10 : 27 }} />
        </Box>
      </Box>
    );
  };

  const renderPaymentName = () => paymentNames[paymentPG] || "Select Payment Method";

  /** --------------------------------
   *  AMOUNT UI COMPONENT
   * -------------------------------- */
  const PaymentAmount = () => {
    return (
      <Stack direction="row" alignItems="baseline" spacing={1}>
        {discountApplied ? (
          <>
            <Typography
              variant="h6"
              sx={{
                textDecoration: "line-through",
                color: "#8d97a1",
                fontWeight: 700,
              }}
            >
              ₹ {totalAmount?.toFixed(2) || fallbackTotal.toFixed(2)}
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 700, color: "#384F6F" }}>
              ₹{" "}
              {(rewardData?.type === "discount"
                ? finalAmount
                : finalAmountAfterDiscount
              )?.toFixed(2) || fallbackDiscountTotal.toFixed(2)}
            </Typography>
          </>
        ) : (
          <Typography variant="h6">
            {comboCart ? (
              <>₹ {(comboCart.totalPrice * comboCart.count).toFixed(2)}</>
            ) : rewardData?.type === "discount" ? (
              <>₹ {finalAmount.toFixed(2)}</>
            ) : (
              <>₹ {finalAmountAfterDiscount.toFixed(2)}</>
            )}
          </Typography>
        )}
      </Stack>
    );
  };

  const GuestClientID = localStorage.getItem("Guest_clientId");

  return (
    <Box sx={{ position: "fixed", bottom: -15, width: "100%" }}>
      {GuestClientID ? (
        <Card sx={{ borderTopLeftRadius: 2, borderTopRightRadius: 2, boxShadow: "0 0 24px rgba(0,0,0,0.08)" }}>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6" sx={{ color: "#384F6F" }}>Almost There</Typography>
                <Typography variant="body2" color="text.secondary">
                  Login or Signup to place your order
                </Typography>
              </Box>

              <Button
                variant="contained"
                sx={{ bgcolor: "rgb(0,177,119)", borderRadius: 2, px: 4, py: 1.5 }}
                onClick={goToLogin}
              >
                LOGIN
              </Button>
            </Stack>
          </CardContent>
        </Card>
      ) : (
        <Card sx={{ borderRadius: "20px 20px 0 0", boxShadow: "0 0 24px rgba(0,0,0,0.08)" }}>
          <CardContent sx={{ p: 2 }}>
            {/* Payment Method */}
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Stack direction="row" spacing={2} alignItems="center">
                {renderPaymentLogo()}
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#384F6F" }}>
                    Payment Method
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {renderPaymentName()}
                  </Typography>
                   <Typography variant="body2" color="red">
                    {localStorage.getItem("defaultPgId")==8&&paymentOptionData[2]?.reason}
                    
                  </Typography>
                </Box>
              </Stack>

              <Stack direction="row" spacing={1} alignItems="center" onClick={goToPaymentOptions} sx={{ cursor: "pointer" }}>
                <Typography variant="body2" color="text.secondary">Change</Typography>
                <img src={changeArrow} alt="change" />
              </Stack>
            </Stack>

            <Divider sx={{ my: 2 }} />

            {/* Total + Button */}
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="caption">Total Amount</Typography>
                <PaymentAmount />
              </Box>
<>

 {localStorage.getItem("defaultPgId")==8&&paymentOptionData[2]?.reason=="INVALID_ON_MACHINE"? <Button
                variant="contained"
                   sx={{
                  bgcolor: "rgb(193, 193, 193)",
                  borderRadius: 2,
                  px: 3,
                  py: 1.5,
                  "&:hover": { bgcolor: "rgb(193, 193, 193)" },
                }}
                endIcon={<img src={proArrow} alt="arrow" />}
                //onClick={handlePlaceOrder}
              >
                Place Order
              </Button>: <Button
                variant="contained"
                sx={{ bgcolor: "rgb(0,177,119)", borderRadius: 2, px: 3, py: 1.5  ,"&:hover": { bgcolor:"rgb(0,177,119)" },}}
                endIcon={<img src={proArrow} alt="arrow" />}
                onClick={handlePlaceOrder}
              >
                Place Order
              </Button>}
</>
             
            </Stack>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default PaymentBottomBar;
